import React, { Component } from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { getTruncatedName } from '../../helpers/utils';
import '../../styles/core.scss';
import css from './dropdown-select.scss';

/* eslint-env browser */

@styleable(css)
class DropdownSelect extends Component {
  static propTypes= {
      rawData: PropTypes.array,
      labelProperty: PropTypes.string,
      selectedIndex: PropTypes.number,
      onChange: PropTypes.func
  };

  constructor(props) {
      super(props);

      this.isChrome = DropdownSelect.detectChrome();

      this.selectedItem = { indexValue: 0 };

      this.onSelectChange = this.onSelectChange.bind(this);
      this.closeAllSelect = this.closeAllSelect.bind(this);
      this.simulateSelect = this.simulateSelect.bind(this);
      this.mimicOptionItemOnClick = this.mimicOptionItemOnClick.bind(this);
      this.mimicSelectedOnClick = this.mimicSelectedOnClick.bind(this);

      this.mimicSelectedClick = false;
  }

  static detectChrome() {
      const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
      return isChrome;
  }
  componentWillUpdate() {} // Not use this, as this is to be deprecated in higher react version.

  onSelectChange(item) {
      const { rawData, onChange } = this.props;

      const selectedIndex = item.target.selectedIndex;
      this.selectedItem = (rawData || [])[selectedIndex];

      if (typeof onChange === 'function') {
          onChange({ ...this.selectedItem });
      }
  }

  componentDidMount() {}

  componentDidUpdate() {}

  simulateSelect(simData, selectedIndex, labelProperty) {
      document.addEventListener('click', this.closeAllSelect);

      let selectedDisplayText = simData[selectedIndex] ? (simData[selectedIndex])[labelProperty] : '';

      const mimicOptionsDivsDoms = simData.map((item, idx) => {
          const optKey = `optKey-${idx}`;
          const selectedItemClassName = `${css['same-as-selected']}`;
          let mimicOptClass = '';
          if (idx === selectedIndex) {
              mimicOptClass = selectedItemClassName;
              selectedDisplayText = item[labelProperty];
          }
          const mimicOptionDivDom = (
              <div
                  role="button"
                  tabIndex={-1}
                  onClick={(event) => { this.mimicOptionItemOnClick(event); }}
                  className={mimicOptClass}
                  key={optKey}
                  data-value={item.indexValue}
                  value={item.indexValue}>{item[labelProperty]}</div>);

          return mimicOptionDivDom;
      });

      const alikeSelectedDisplay = (
          <div
              role="button"
              tabIndex={-1}
              onClick={(event) => { this.mimicSelectedOnClick(event); }}
              key="mimicSelectedDisplay"
              className={`${css['select-selected']}`}>{selectedDisplayText}</div>
      );

      const mimicSelect = (
          <div key="mimicSelect" className={`${css['select-items']} ${css['select-hide']}`} >
              {mimicOptionsDivsDoms}
          </div>
      );

      return [alikeSelectedDisplay, mimicSelect];
  }

  // not fully simulated yet, and to be refactored more reactive manner later
  mimicOptionItemOnClick(event) {
      const thisElement = event.target;

      const sameAsSelectedClassName = `${css['same-as-selected']}`;
      const realSelect = thisElement.parentNode.parentNode.getElementsByTagName('select')[0];
      const siblingAlikeSelected = thisElement.parentNode.previousSibling;

      for (let rOptIdx = 0; rOptIdx < realSelect.length; rOptIdx += 1) {
          if (realSelect.options[rOptIdx].value === thisElement.dataset.value) {
              realSelect.selectedIndex = rOptIdx;
              siblingAlikeSelected.innerHTML = thisElement.innerHTML;
              this.onSelectChange({ target: realSelect });
              // const event = new Event('change');
              // realSelect.dispatchEvent(event);
              // why not call this "realSelect.onChange" ?

              const mimicSelectedOption = thisElement.parentNode.getElementsByClassName(sameAsSelectedClassName);
              for (let cleanIdx = 0; cleanIdx < mimicSelectedOption.length; cleanIdx += 1) {
                  mimicSelectedOption[cleanIdx].removeAttribute('class');
              }
              thisElement.setAttribute('class', sameAsSelectedClassName);
              break;
          }
      }
      // siblingAlikeSelected.click();
  }

  // not fully simulated yet, and to be refactored more reactive manner later
  mimicSelectedOnClick(/* event */) {
      // event.stopPropagation();
      // event.nativeEvent.stopImmediatePropagation();
      this.mimicSelectedClick = true;
      const selectSelectedClassName = `${css['select-selected']}`;
      const selectHideClassName = `${css['select-hide']}`;
      const selectArrowActive = `${css['select-arrow-active']}`;
      const mySelector = this.selectBox.children;
      const alikeSelected = mySelector[0].getElementsByClassName(selectSelectedClassName)[0];
      // this.closeAllSelect(alikeSelected.nextSibling);
      alikeSelected.nextSibling.classList.toggle(selectHideClassName);
      alikeSelected.classList.toggle(selectArrowActive);
  }

  // not fully simulated yet, and to be refactored more reactive manner later
  closeAllSelect(elmnt) {
      if (!this.selectBox) {
          this.mimicSelectedClick = false;
          return;
      }

      const mySelector = this.selectBox.children[0];
      const selectHideClassName = `${css['select-hide']}`;
      const selectItems = `${css['select-items']}`;

      const mimicSelectItem = mySelector.getElementsByClassName(selectItems)[0];
      if (mimicSelectItem && elmnt !== mimicSelectItem && this.mimicSelectedClick !== true) {
          mimicSelectItem.classList.add(selectHideClassName);
      }
      this.mimicSelectedClick = false;
  }

  render() {
      const { rawData, selectedIndex, labelProperty } = this.props;
      const myIndex = selectedIndex || 0;

      let selectDisplay = false;
      if (rawData && rawData.length > 1) {
          selectDisplay = true;
      }

      this.selectedItem = (rawData || [])[myIndex] || { indexValue: 0 };

      const optionsDoms = selectDisplay ? (rawData || []).map((item, idx) => {
          const optKey = `optKey-${idx}`;
          if (!item.keyValue) {
              item.indexValue = idx;
          }
          const optionDom = (
              <option key={optKey} value={item.indexValue}>
                  {getTruncatedName(item[labelProperty], 'selectOptionName')}
              </option>);
          return optionDom;
      }) : undefined;

      let selectClassName = this.isChrome ? `${css['real-select-hide']}` : '';
      selectClassName = selectDisplay ? selectClassName : `${css['real-select-hide']}`;

      const selectEllipsisLabel = this.isChrome ? '' : (
          <div className={css['select-ellipsis-label']} >{this.selectedItem[labelProperty]}</div>
      );

      const mimicSelectDom = (this.isChrome && selectDisplay) ?
          this.simulateSelect(rawData, selectedIndex, labelProperty) : undefined;

      const textEllipsisLabel = selectDisplay ? undefined : (
          <div className={css['text-ellipsis-label']} >{this.selectedItem[labelProperty]}</div>
      );

      return (
          <div
              className={css['dropdown-select-box']}
              ref={(selectBox) => { this.selectBox = selectBox; }}>

              <div className={css.selector}>
                  <select
                      className={selectClassName}
                      value={this.selectedItem.indexValue}
                      onChange={(event) => { this.onSelectChange(event); }}>
                      {optionsDoms}
                  </select>
                  {selectEllipsisLabel}
                  {mimicSelectDom}
              </div>
              {textEllipsisLabel}
          </div>
      );
  }
}

export default DropdownSelect;



// WEBPACK FOOTER //
// ./components/dropdown-select/dropdown-select.js